import React, { useRef, useEffect } from "react";
import ReactInputMask from "react-input-mask";
import { useField } from "@unform/core";

const InputMask = ({ label, name, ...rest }) => {
	const inputRef = useRef(null);
	const { fieldName, registerField, defaultValue, error } = useField(name);

	useEffect(() => {
		registerField({
			name: fieldName,
			ref: inputRef.current,
			path: "value",
			setValue(ref, value) {
				ref.setInputValue(value);
			},
			clearValue(ref) {
				ref.setInputValue("");
			},
		});
	}, [fieldName, registerField]);

	return (
		<label>
			<p>{label}</p>
			<ReactInputMask
				ref={inputRef}
				defaultValue={defaultValue}
				{...rest}
			/>
			{error && <span className='require'>{error}</span>}
		</label>
	);
};

export default InputMask;
